import { EntityInterface } from '@gfe/core/models/entities/entity-visualization-interface';
import { TableConfig } from '@gfe/shared/components/table/table.model';

import { EntityComponent } from './entity.component';

export function buildTableConfig<T>(
  entityComponent: EntityComponent<T>,
  toggleRowSelection: (row: EntityInterface<T>) => void
): TableConfig<EntityInterface<T>> {
  const availableDetails = entityComponent
    .availableDetailEntityTypes()
    .map((entityType) => ({ entityType }));
  return {
    // Must be a flat key on EntityInterface: it feeds trackByFn's `item[rowId]`
    // lookup. 'raw.uid' is not a real property (bracket access is not a nested
    // path resolver), so it fell back to $index and defeated row identity.
    rowId: 'uid',
    bordered: true,
    horizontalScroll: true,
    columnColors: true,
    editable:
      entityComponent.contextType() === 'edition'
        ? undefined
        : {
            inline: false,
            newTab: entityComponent.editionTransformerSchema() !== null,
            disabledReason: entityComponent.planHeld()
              ? entityComponent.translate.instant('features.plan.edit.held.write_disabled')
              : undefined
          },
    availableDetails,
    columnActionSettings: {
      sortable: true,
      filterable: true,
      resizeable: true,
      groupable: false,
      movable: true,
      hideable: true
    },
    selection: {
      enabled: true,
      multiple: true,
      mode: 'checkbox',
      action: (row: EntityInterface<T>) => toggleRowSelection(row)
    }
  };
}
